

























































import { get } from 'vuex-pathify';
import accounts from '@/mixins/accounts';
import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';
export default mixins(accounts, auth).extend({
  name: 'User-Permissions',
  components: {},
  data: () => ({
    search: '',
    headers: [
      {
        text: 'Member',
        align: 'start',
        sortable: true,
        value: 'first_name'
      },
      { text: 'Role(s)', value: 'id' }
    ]
  }),
  computed: {
    miniCompanyImage: get('app/miniCompanyImage')
  },
  mounted() {
    this.fetchAccounts();
  }
});
